export default __webpack_public_path__ + "static/media/notice-activity.70c94952.png";